<template>
  <div class="layout">
    <el-container class="maincontainer">
      <el-aside style="width: auto;">
        <x-aside></x-aside>
      </el-aside>
      <!-- <el-container> -->
        <!-- <el-main class="main-width"> -->
          <router-view></router-view>
          <x-tip></x-tip>
        <!-- </el-main> -->
      <!-- </el-container> -->
    </el-container>
  </div>
</template>

<script>
import XAside from '@/components/Layout/Aside'
import XTip from '@/components/Layout/Tip'
export default {
  name: 'Layout',
  components: {
    XAside,
    XTip
  }
}
</script>

<style scoped lang="less">
.layout {
  .el-container {
    height: 100%;
    // height: 10%;
    .el-header,
    .el-footer {
      padding: 0;
      background: #2c365c;
      text-align: center;
      text-align: -webkit-center;
      text-align: -moz-center;
    }
    .el-aside {
      // background-color: #FFFFFF;
      background-color: #DDE1EC;
      line-height: 200px;
      text-align: center;
      text-align: -webkit-center;
      text-align: -moz-center;
    }
    .el-header {
      height: 3.5rem !important;
      line-height: 3.5rem !important;
    }
    // .main-width{
    //   width: 30vh;
    // }
    .el-footer {
      height: 3rem !important;
      line-height: 3rem !important;
    }
    // @media (max-width: 992px) {
    // .el-aside{
    // width: 100% !important;
    // overflow: hidden;
    // }
  // }
  }
  .el-main {
    padding: 4.5rem 0 2.5rem 0;
    justify-content: center;
    text-align: -webkit-center;
    text-align: -moz-center;
  }
  .maincontainer{
    height: 100vh;
    flex: 0;
  }
  @media (max-width: 992px) {
  .maincontainer{
  height: auto;
  }
  .el-container {
    width: 100% !important;
    overflow: hidden;
    // display: block;
  }
  .el-main {
    padding: 0;
  }
}
}

</style>



// WEBPACK FOOTER //
// src/pages/Layout/Layout.vue